<script>
    /* МАСТЕР «ВЫСТАВИТЬ ЛОТ» — три шага в одном экране:
       что продаём (категория) → что именно (список имущества) → описание и
       стартовая цена. Справа всё время видно, как лот будет выглядеть в
       витрине, поэтому игрок понимает результат до отправки. */
    import { onDestroy } from 'svelte'
    import { format } from 'api/formatter'
    import { onInputFocus, onInputBlur } from '../../data'
    import Icon from './icon.svelte'
    import { CATS, catName } from './data'

    export let sellCat = -1;
    export let sellItems = [];
    export let onPickCat = () => {};
    export let onResetCat = () => {};
    export let onSubmit = () => {};
    export let onBack = () => {};

    let itemId = -1;
    let itemName = '';
    let text = '';
    let price = '';
    let confirm = false;

    $: step = sellCat < 0 ? 1 : itemId < 0 ? 2 : 3;
    $: value = Number (String (price).replace (/[^0-9]/g, ""));

    const pickCat = (id) => {
        itemId = -1; itemName = ''; confirm = false;
        onPickCat (id);
    };

    const pickItem = (item) => {
        itemId = item.id;
        itemName = item.name;
        confirm = false;
    };

    const send = () => {
        if (!text || text.trim ().length < 3)
            return window.notificationAdd (4, 9, 'Опишите лот — хотя бы пара слов', 3000);
        if (!value)
            return window.notificationAdd (4, 9, 'Укажите стартовую цену', 3000);

        onSubmit (itemId, text.trim (), value);
        confirm = false;
    };

    onDestroy (() => onInputBlur ());
</script>

<div class="mkpage">
    <div class="mksteps">
        <div class="mkstep" class:on={step === 1} class:done={step > 1}><i>1</i>Категория</div>
        <div class="mkstep__line"></div>
        <div class="mkstep" class:on={step === 2} class:done={step > 2}><i>2</i>Что продаём</div>
        <div class="mkstep__line"></div>
        <div class="mkstep" class:on={step === 3}><i>3</i>Цена и описание</div>
        <div class="mkseg" style="margin-left:auto">
            <div on:keypress={() => {}} on:click={onBack}>← К витрине</div>
        </div>
    </div>

    <div class="mkwiz">
        <div class="mkwiz__main">
            {#if step === 1}
                {#each CATS as cat}
                    <div class="mkpick" on:keypress={() => {}} on:click={() => pickCat (cat.id)}>
                        <div class="mkpick__ico"><Icon name={cat.icon}/></div>
                        <div>
                            <p class="mkpick__name">{cat.name}</p>
                            <p class="mkpick__hint">{cat.hint}</p>
                        </div>
                        <b class="mkpick__go">›</b>
                    </div>
                {/each}
                <p class="mknote">Лот уходит на торги: игроки предлагают цену, победитель получает имущество,
                    деньги приходят вам. Снять лот с торгов нельзя.</p>
            {:else if step === 2}
                <div class="mkpick on" on:keypress={() => {}} on:click={onResetCat}>
                    <div class="mkpick__ico"><Icon name={CATS[sellCat] ? CATS[sellCat].icon : 'tag'}/></div>
                    <div>
                        <p class="mkpick__name">{catName (sellCat)}</p>
                        <p class="mkpick__hint">нажмите, чтобы выбрать другую категорию</p>
                    </div>
                </div>

                {#if sellItems && sellItems.length}
                    {#each sellItems as item}
                        <div class="mkpick" on:keypress={() => {}} on:click={() => pickItem (item)}>
                            <div class="mkpick__ico"><Icon name={CATS[sellCat] ? CATS[sellCat].icon : 'tag'}/></div>
                            <div>
                                <p class="mkpick__name">{item.name}</p>
                                <p class="mkpick__hint">выставить на торги</p>
                            </div>
                            <b class="mkpick__go">›</b>
                        </div>
                    {/each}
                {:else}
                    <div class="mkempty">
                        <Icon name="tag"/>
                        <p>В этой категории у вас ничего нет</p>
                        <span>Выберите другую категорию — продать можно только своё имущество</span>
                    </div>
                {/if}
            {:else}
                <div class="mkcard">
                    <p class="mkcard__title">Описание лота</p>
                    <div class="mkinput mkarea">
                        <textarea bind:value={text} placeholder="Расскажите о лоте: состояние, район, что входит в сделку"
                                  on:focus={onInputFocus} on:blur={onInputBlur} on:input={() => confirm = false}></textarea>
                    </div>
                    <p class="mknote">Это описание увидят все игроки в витрине маркетплейса.</p>
                </div>

                <div class="mkcard">
                    <p class="mkcard__title">Стартовая цена</p>
                    <div class="mkbet">
                        <div class="mkinput">
                            <em>$</em>
                            <input type="text" bind:value={price} placeholder="Например: 250000"
                                   on:focus={onInputFocus} on:blur={onInputBlur} on:input={() => confirm = false}>
                        </div>
                        <div class="mkquick">
                            <div on:keypress={() => {}} on:click={() => price = '100000'}>100 000</div>
                            <div on:keypress={() => {}} on:click={() => price = '500000'}>500 000</div>
                            <div on:keypress={() => {}} on:click={() => price = '1000000'}>1 000 000</div>
                        </div>
                        {#if !confirm}
                            <div class="mkbtn" class:off={!value || !text.trim ()} on:keypress={() => {}}
                                 on:click={() => value && text.trim () && (confirm = true)}>Выставить лот</div>
                        {:else}
                            <p class="mknote">
                                Выставить <b>{itemName}</b> за <b>{format ("money", value)}$</b>?
                                Торги начнутся сразу и отменить их будет нельзя.
                            </p>
                            <div class="mkbtn" on:keypress={() => {}} on:click={send}>Да, выставляю</div>
                            <div class="mkbtn ghost" on:keypress={() => {}} on:click={() => confirm = false}>Ещё подумаю</div>
                        {/if}
                    </div>
                </div>
            {/if}
        </div>

        <!-- ПРЕДПРОСМОТР: ровно та карточка, которую увидят в витрине -->
        <div class="mkwiz__side">
            <div class="mkcard">
                <p class="mkcard__title">Как увидят другие</p>
                <div class="mklot" style="cursor:default">
                    <div class="mklot__photo">
                        <div class="mkblank">
                            <Icon name={CATS[sellCat] ? CATS[sellCat].icon : 'tag'}/>
                            <p>{sellCat >= 0 ? catName (sellCat) : 'Категория'}</p>
                        </div>
                        <div class="mkchip own">Мой лот</div>
                    </div>
                    <div class="mklot__body">
                        <p class="mklot__title">{itemName || 'Выберите имущество'}</p>
                        <p class="mklot__text">{text || 'Здесь будет ваше описание'}</p>
                        <div class="mklot__price">
                            <p>Стартовая цена</p>
                            <b>{format ("money", value)}$</b>
                        </div>
                    </div>
                </div>
            </div>
            <p class="mknote">Ставки принимаются, пока идут торги. Победителем становится тот,
                чья цена окажется старшей к моменту окончания.</p>
        </div>
    </div>
</div>
